/* istanbul ignore file */
import React from "react";
import { KlantprofielAlgemeenHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import KlantprofielChapter from "./KlantprofielChapter";

interface Props {
  hoofdstuk: KlantprofielAlgemeenHoofdstuk;
}

const BijlageKlantprofielAlgemeenChapter: React.FC<Props> = ({ hoofdstuk }) => {
  return (
    <>
      {hoofdstuk?.doelstelling && (
        <KlantprofielChapter
          title={"Algemeen - Doelstelling"}
          questions={hoofdstuk.doelstelling}
        />
      )}
      {hoofdstuk?.toekomstPerspectief && (
        <KlantprofielChapter
          title={"Algemeen - Toekomstperspectief"}
          questions={hoofdstuk.toekomstPerspectief}
        />
      )}
      {hoofdstuk?.kennisEnErvaring && (
        <KlantprofielChapter
          title={"Algemeen - Risico en Kennis"}
          questions={hoofdstuk.kennisEnErvaring}
        />
      )}
    </>
  );
};

export default BijlageKlantprofielAlgemeenChapter;
